<!-- @format -->

<individual-form>
  <div class="container_heading">
    <h1 class="heading-01 heading_application">個人情報登録</h1>
    <ul class="breadcrumb">
      <li class="breadcrumb-item">
        <a href="{ routes.makePath('top-tag') }" class="home">ホーム</a>
      </li>
      <li class="breadcrumb-item">個人情報登録</li>
    </ul>
  </div>
  <!--/.container_heading-->

  <div class="contents_block">
    <p>
      こちらの個人情報はCROCO株式会社とのお取引（CROCOデスク）にて、ワーカー様とのお取引やお支払い等が生じる際に使用します。
    </p>
    <br />
    <form class="application_form">
      <template each="{ propName in ['name', 'kana'] }">
        <label class="form-heading required" for="{ propName }">
          { Fields[propName] }
        </label>
        <p if="{ props.errors[propName] }" class="error">
          { props.errors[propName] }
        </p>
        <input
          class="text_input { props.errors[propName] ? 'is-error' : '' }"
          type="text"
          name="{ propName }"
          id="{ propName }"
          placeholder="{ propName=='name'? '姓名' : 'セイメイ' }"
          is="binding"
          data="{ state.params }"
        />
      </template>

      <h3 class="form-heading required">住所</h3>
      <div class="inner_form">
        <template each="{ propName in ['zip'] }">
          <label class="form-heading required" for="{ propName }">
            { Fields[propName] }
          </label>
          <p if="{ props.errors[propName] }" class="error">
            { props.errors[propName] }
          </p>
          <input
            class="text_input { props.errors[propName] ? 'is-error' : '' }"
            type="text"
            name="{ propName }"
            id="{ propName }"
            placeholder="0000000"
            is="binding"
            data="{ state.params }"
          />
        </template>

        <template each="{ propName in ['pref'] }">
          <label class="form-heading required" for="{ propName }">
            {Fields[propName]}
          </label>
          <p if="{ props.errors[propName] }" class="error">
            { props.errors[propName] }
          </p>
          <select
            name="{ propName }"
            id="{ propName }"
            class="text_input narrow sort-list"
            onchange="{ onPref }"
          >
            <option each="{ pref in props.prefs }" value="{ pref.id }">
              { pref.jname }
            </option>
          </select>
        </template>

        <template each="{ propName in ['address1'] }">
          <label class="form-heading required" for="{ propName }">
            { Fields[propName] }
          </label>
          <p if="{ props.errors[propName] }" class="error">
            { props.errors[propName] }
          </p>
          <input
            class="text_input { props.errors[propName] ? 'is-error' : '' }"
            type="text"
            name="{ propName }"
            id="{ propName }"
            placeholder="渋谷区代々木4-33-10"
            is="binding"
            data="{ state.params }"
          />
        </template>

        <template each="{ propName in ['address2'] }">
          <label class="form-heading" for="{ propName }">
            { Fields[propName] }
          </label>
          <p if="{ props.errors[propName] }" class="error">
            { props.errors[propName] }
          </p>
          <input
            class="text_input { props.errors[propName] ? 'is-error' : '' }"
            type="text"
            name="{ propName }"
            id="{ propName }"
            placeholder="トーシンビル6階"
            is="binding"
            data="{ state.params }"
          />
        </template>
      </div>
      <!--/.inner_form-->

      <template each="{ propName in ['tel'] }">
        <label class="form-heading required" for="{ propName }">
          { Fields[propName] }
        </label>
        <p if="{ props.errors[propName] }" class="error">
          { props.errors[propName] }
        </p>
        <input
          class="text_input narrow { props.errors[propName] ? 'is-error' : '' }"
          type="text"
          name="{ propName }"
          id="{ propName }"
          placeholder="0000000000"
          is="binding"
          data="{ state.params }"
        />
      </template>
      <!--/.container_input-->

      <div class="container_button">
        <button
          class="button button-primary"
          type="button"
          value="登録"
          data-target=""
          onclick="{ onSubmit }"
        >
          確認画面へ
        </button>
      </div>
      <!--/.container_button-->
    </form>

    <!--/.application_form-->
  </div>
  <!--/.contents_block-->

  <script>
    import di from "dependency-injection";
    import routes from "@model/menu-routes.js";

    export default {
      Fields: {
        name: "氏名",
        kana: "氏名(かな)",
        zip: "郵便番号",
        pref: "都道府県",
        address1: "住所1（市区町村 番地）",
        address2: "住所2（建物名、フロアなど）",
        tel: "電話番号",
      },
      state: {
        params: {},
      },
      onBeforeMount(props, state) {
        this.routes = routes;
        const isEmpty = Object.keys(props.params).length == 0;
        for (const key of Object.keys(this.Fields)) {
          this.state.params[key] = isEmpty ? "" : props.params[key];
        }
      },
      onMounted(props, state) {
        this.onUpdated(props, state);
      },
      onUpdated(props, state) {
        this.$('[name="pref"]').value = state.params.pref;
      },
      shouldUpdate(newProps, curProps) {
        if (newProps.params != curProps.params) {
          this.state.params = newProps.params;
        }
      },
      onPref(e) {
        this.state.params.pref = e.target.value;
      },
      onTextarea(e) {
        this.state.params.content = e.target.value;
      },
      onSubmit(e) {
        this.props.onConfirm(this.state.params);
      },
    };
  </script>
</individual-form>
